<template>
  <v-app>
    <div id="app" :class="{ 'app--site-chrome': showChrome, 'app--profile-nudge': showProfileNudge }">
      <SiteHeader v-if="showChrome" />
      <SubHeader v-if="showProfileNudge" />
      <router-view class="app-main" />
      <SiteFooter
        v-if="showChrome"
        :show-standard="footerConfig.showStandard"
        :show-seo="footerConfig.showSeo"
        :standard-variant="footerConfig.standardVariant"
        :mobile-bottom-pad="footerConfig.mobileBottomPad"
      />
      <VisumeModal v-if="showChrome" />
    </div>
  </v-app>
</template>

<script>
const VisumeModal = () => import(/* webpackPrefetch: true */ '@/components/VisumeModal');
const SiteHeader = () => import(/* webpackPrefetch: true */ '@/components/chrome/SiteHeader');
const SubHeader = () => import(/* webpackPrefetch: true */ '@/components/SubHeader');
const SiteFooter = () => import(/* webpackPrefetch: true */ '@/components/chrome/SiteFooter');
import { getFooterConfig } from '@/utils/previewRoutes';

export default {
  name: 'App',
  components: {
    SiteHeader,
    SubHeader,
    SiteFooter,
    VisumeModal,
  },
  data() {
    return {
      profileNudgeDismissed: !!sessionStorage.getItem('hc-profile-nudge-dismissed-v2'),
    };
  },
  created() {
    this.$root.$on('profile-nudge-dismissed', this.onProfileNudgeDismissed);
  },
  beforeDestroy() {
    this.$root.$off('profile-nudge-dismissed', this.onProfileNudgeDismissed);
  },
  computed: {
    showChrome() {
      return this.$route.meta.header === 1;
    },
    showProfileNudge() {
      if (this.profileNudgeDismissed) return false;
      const seeker = this.$cookies.get('hire-seeker');
      if (!this.showChrome || !seeker) return false;
      const path = this.$route.path;
      if (path.startsWith('/myprofile') || path.startsWith('/questionnaire')) return false;
      return !seeker.resume_path || !seeker.visume_path;
    },
    footerConfig() {
      return getFooterConfig(this.$route.path);
    },
  },
  methods: {
    onProfileNudgeDismissed() {
      this.profileNudgeDismissed = true;
    },
  },
};
</script>
